import { fetchPath } from "./fetch-path";

export function isImage(src?: string): src is string {
  if (!src) return false;

  if (src.includes("unsplash.com")) return true;
  if (src.includes("i.vimeocdn.com")) return true;

  return /\.(png|jpg|jpeg|gif|webp)$/i.test(fetchPath(src));
}
